/* eslint-disable import/no-default-export */
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import {
    contactDealerModalTypes,
    PDP_PASSWORD_RESET_ORIGIN,
    SHOW_CONTACT_DEALER_PARAM,
} from '../src/ContactDealerModal/helpers/constants';
import { handleLocaleUrl, GLOBAL_CLIENT_ONLY_LOCALE } from 'dibs-intl/exports/handleLocaleUrl';

export default function contactDealerLauncher({
    currency,
    environment,
    itemId,
    selectedSkuId,
    launchOrigin,
    modalType,
    sellerId,
    showAppInstallPrompt,
    userId,
    onSuccessfulShippingQuoteRequest,
    onSuccessfulContactSellerRequest,
    itemQuantity,
}) {
    const modalContainer = document.createElement('div');
    import(
        /* webpackChunkName: "contactDealerModal" */
        '../src/ContactDealerModal/contactDealerAsyncImports'
    ).then(mod => {
        const root = createRoot(modalContainer, { identifierPrefix: 'contactDealerModal' });
        const unmount = () => root.unmount();
        const { components, helpers } = mod;

        const rendererProps = {
            environment,
            itemId,
            selectedSkuId,
            launchOrigin,
            modalType,
            pageCurrency: currency,
            sellerId,
            showAppInstallPrompt,
            userId,
            onSuccessfulShippingQuoteRequest,
            onSuccessfulContactSellerRequest,
            unmount,
            itemQuantity,
        };

        const { ContactDealerModal, IntlProvider } = components;
        const { serverVars } = helpers;

        root.render(
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <ContactDealerModal {...rendererProps} />
            </IntlProvider>
        );
    });
}

export const useContactDealerAutoModal = ({
    launchOrigin = PDP_PASSWORD_RESET_ORIGIN,
    itemId,
    selectedSkuId,
    userId,
    environment,
    currency,
    itemQuantity,
}) => {
    useEffect(() => {
        if (!userId || !itemId || typeof window === 'undefined') {
            return;
        }
        const searchParams = new URLSearchParams(window.location.search);
        const showContactDealerParam = searchParams.get(SHOW_CONTACT_DEALER_PARAM);

        if (showContactDealerParam) {
            searchParams.delete(SHOW_CONTACT_DEALER_PARAM);
            const cleanSearchParams = searchParams.toString();
            const searchParamString = cleanSearchParams ? `?${cleanSearchParams}` : '';
            window.history.replaceState(
                '',
                '',
                handleLocaleUrl(
                    window.location.pathname + `${searchParamString}`,
                    GLOBAL_CLIENT_ONLY_LOCALE
                )
            ); // remove the param so we only trigger modal once
            contactDealerLauncher({
                environment,
                itemId,
                selectedSkuId,
                modalType: contactDealerModalTypes.CONTACT_DEALER,
                launchOrigin,
                currency,
                userId,
                itemQuantity,
            });
        }
    }, [currency, userId, itemId, environment, launchOrigin, selectedSkuId, itemQuantity]);
};
